export const getNextClientId = (() => {
  let clientId = 0;
  return () => {
    return clientId++;
  };
})();
